<template>
    <div>
        <div v-for="(n, index) in contents"   :key="index">
            <v-row>
                <!-- <v-col cols="4" md="2">
                    <v-card class="elevation-2">
                        <v-img
                        max-height="200" 
                        contain
                        :src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                        class="transparent lighten-2"
                        >
                            <template v-slot:placeholder>
                            <v-layout
                                fill-height
                                align-center
                                justify-center
                                ma-0
                                >
                                <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                            </v-layout>
                            </template>
                        </v-img>
                    </v-card>
                </v-col> -->
                <v-col cols="6" md="2" v-if="n.Files[0]">
                    <v-card class="elevation-2">
                        <v-img
                        :src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                        class="transparent lighten-2"
                        >
                            <template v-slot:placeholder>
                            <v-layout
                                fill-height
                                align-center
                                justify-center
                                ma-0
                                >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-layout>
                            </template>
                        </v-img>
                    </v-card>
                </v-col>
                <v-col cols="6" md="7">
                    <div class="d-flex align-center" style="height: 100%">
                        <p>
                            <a :href="`#/Join%20Us/${$route.params.contentType}/profile/${n.Title}`" class="title" style="font-family: 'Mv Eamaan XP' !important;">{{n.Title.split(',').length > 0 ? n.Title.split(',')[0] : n.Title}}</a><br>
                            <span class="subheading text-xs-center font-weight-bold">{{n.Title.split(', ')[1]}}</span>
                        </p>
                    </div>
                </v-col>
            </v-row>
            <!-- <p class="mt-3 text-xs-center"><a class="title" :href="`#/Join%20Us/${$route.params.contentType}/profile/${n.Title}`" style="font-family: 'Mv Eamaan XP' !important;">{{n.Title}}</a></p> -->
            
            <p class="text-right text-justify font-weight-bold collegues-quote" style=" "   v-html="getQuote(n.Body)"></p>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['contents'],
        methods: {
            getQuote (item) {
                let splitSentence = item.split('ފުރަތަމަ ޞަފްޙާގައި ހިމަނާ ކޯޓޭޝަން')
                if (splitSentence.length > 1) {
                    const regex = /<\/[^>]+>/gi;
                    return splitSentence[1].replace(regex, ``)
                } else {
                    return ''
                }
             }
        }
    }
</script>
<style>
.collegues-quote>p {
    font-size: 20px !important
}
</style>